import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import user_icon from "../../../../../../Assets/svg/user_icon.svg";
import email_icon from "../../../../../../Assets/svg/email_icon.svg";
import edit_pen from "../../../../../../Assets/svg/edit_pen.svg";
import "react-phone-input-2/lib/style.css";
import {
  useFetchUserProfileQuery,
  useUpdateUserProfileMutation,
} from "store/services/user.service";
import { Formik, Field, ErrorMessage } from "formik";
import { profileSchema } from "helpers/yup_validator";
import toast from "react-hot-toast";
import ChangePassword from "./component/ChangePassword";
import ChangeEmail from "./component/ChangeEmail";
import ErrorComponent from "components/shared/ErrorComponent";
import Loader from "components/shared/Loader";

const ProfileSec = () => {
  const { data: userProfile, isLoading, isError, refetch } = useFetchUserProfileQuery();
  const [updateUserProfile] = useUpdateUserProfileMutation();
  const [editMode, setEditMode] = useState(false);
  const [changePasswordMode, setChangePasswordMode] = useState(false);
  const [phone, setPhone] = useState("");
  const [changeEmailMode, setChangeEmailMode] = useState(false);

  useEffect(() => {
    if (userProfile?.phone) {
      setPhone(userProfile.phone);
    }
  }, [userProfile]);

  const handleSave = async (values) => {
    try {
      await updateUserProfile({ ...values, phone }).unwrap();
      toast.success("Profile Updated Successfully");
      setEditMode(false);
      refetch();
    } catch (error) {
      console.error("Error updating profile", error);
      toast.error("Failed to update profile");
    }
  };

  return (
    <div className="inner">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ): isError ? (
            <ErrorComponent />
          ): (userProfile && !changePasswordMode && !changeEmailMode) && (
            <Formik
              initialValues={{
                name: userProfile.name || "",
                email: userProfile.email || "",
                phone: phone || userProfile.phone || "",
              }}
              validationSchema={profileSchema}
              onSubmit={handleSave}
            >
              {({ handleSubmit, handleChange, values }) => (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg="6" className="my-3">
                      <div className="position-relative labelInput">
                        <div className="iconWithText position-relative">
                          <Field
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Full Name"
                            disabled={!editMode}
                            value={values.name}
                            onChange={handleChange}
                          />
                          <span
                            className="icn position-absolute"
                            style={{ left: "8px" }}
                          >
                            <img src={user_icon} alt="" />
                          </span>
                        </div>
                        <label
                          htmlFor="name"
                          className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                        >
                          Full Name
                        </label>
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>
                    <Col lg="6" className="my-3">
                      <div className="position-relative labelInput">
                        <div className="iconWithText position-relative">
                          <PhoneInput
                            country={"us"}
                            value={phone}
                            disabled={!editMode}
                            onChange={(newPhone) => setPhone(newPhone)}
                            inputProps={{
                              name: "phone",
                              required: true,
                              autoFocus: true,
                            }}
                          />
                        </div>
                        <label
                          htmlFor="phone"
                          className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                        >
                          Phone Number
                        </label>
                        <ErrorMessage
                          name="phone"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>
                    <Col lg="6" className="my-3">
                      <div className="position-relative labelInput">
                        <div className="iconWithText position-relative">
                          <Field
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            disabled
                            value={values.email}
                            onChange={handleChange}
                          />
                          <span
                            className="icn position-absolute"
                            style={{ left: "8px" }}
                          >
                            <img src={email_icon} alt="" />
                          </span>
                        </div>
                        <label
                          htmlFor="email"
                          className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                        >
                          Email
                        </label>
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      {editMode ? (
                        <div className="d-flex align-items-center gap-10 btnWrpperGroup">
                          <Button
                            type="button"
                            className="d-inline-flex align-items-center justify-content-center commonBtn cancelBtn w-100"
                            onClick={() => setEditMode(false)}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            className="d-inline-flex align-items-center justify-content-center commonBtn w-100"
                          >
                            Save
                          </Button>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center gap-10">
                          <div>
                            <Col lg="12">
                              <span
                                role="button"
                                className="themeClr"
                                variant="transparent"
                                onClick={() => setEditMode(true)}
                              >
                                <span className="icn me-2 " role="button">
                                  <img src={edit_pen} alt="" />
                                </span>
                                Edit Profile
                              </span>
                            </Col>
                          </div>
                          <div>
                            <Col lg="12" className="my-2">
                              <Link
                                to="#"
                                className="fw-sbold"
                                onClick={() => setChangePasswordMode(true)}
                              >
                                Change Password
                              </Link>
                            </Col>
                          </div>
                          <div>
                            <Col lg="12" className="my-2">
                              <Link
                                to="#"
                                className="fw-sbold"
                                onClick={() => setChangeEmailMode(true)}
                              >
                                Change Email
                              </Link>
                            </Col>
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}

          {changePasswordMode && (
            <ChangePassword onCancel={() => setChangePasswordMode(false)} />
          )}
          {changeEmailMode && (
            <ChangeEmail onCancel={() => setChangeEmailMode(false)} refetch={refetch} />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProfileSec;
